/* eslint-disable camelcase */
/**
 * Press Release Box Analytics
 *
 * This script handles tracking when the press release sidebar box loads via HTMX.
 * It adds event listeners for HTMX after-settle events.
 */

(function() {
  /**
   * Given a DOMElement representing a press release, extract the event info from the
   * data- attributes, and send it to GTM
   * @param {DOMElement} pressReleaseElement The press release to log as seen in GTM
   */
  const sendPRGTMEvent = (pressReleaseElement) => {
    const event = pressReleaseElement.getAttribute('data-gtm-event');
    const pressrelease_location = pressReleaseElement.getAttribute('data-gtm-pressrelease_location');
    const pressrelease_url = pressReleaseElement.getAttribute('data-gtm-pressrelease_url');
    if (event && pressrelease_location && pressrelease_url) {
      window.dataLayer.push({ event, pressrelease_location, pressrelease_url });
    } else {
      // eslint-disable-next-line no-console
      console.error('GTM event missing data: event: ', event, ', url: ', pressrelease_url, ', location: ', pressrelease_location);
    }
  };

  // Listen for HTMX press release box loaded events
  document.addEventListener('htmx:afterSettle', (event) => {
    const updatedElement = event.detail?.elt;
    if (updatedElement.classList.contains('sidebar-box-list')) {
      const pressReleases = updatedElement.querySelectorAll('[data-gtm-event]');
      pressReleases.forEach((pr) => sendPRGTMEvent(pr));
    }
  });
}());
